import { routes } from "@constants/routes";
import {
  LanguageForm,
  LanguageTable,
  NativeLanguageForm,
  useGetLanguageCertificateByIdLazyQuery,
  useResumeStore,
  UserTypeEnum,
} from "@cpj-ai/panel-npm-package";
import { useGetLanguagesCertificatesQuery, useGetNativeLanguagesQuery } from "@graphql/generated";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export type TLanguageState = "TABLE" | "FORM";

interface ILanguageTabContent {
  handleNextTab: () => void;
}

const LanguageTabContent = ({ handleNextTab }: ILanguageTabContent) => {
  const [languageState, setLanguageState] = useState<TLanguageState>("TABLE");
  const { setLanguageEditId } = useResumeStore();
  const { data, refetch, loading } = useGetLanguagesCertificatesQuery();
  const location = useLocation();
  const { data: nativeLanguages, loading: loadingGetNativeLanguage } = useGetNativeLanguagesQuery();
  const [getLanguageInfoById, { data: languageInfoByIdData, loading: languageInfoByIdLoading }] =
    useGetLanguageCertificateByIdLazyQuery();

  useEffect(() => {
    setLanguageEditId(undefined);
  }, [setLanguageEditId]);

  return (
    <div>
      {languageState === "TABLE" ? (
        <>
          <NativeLanguageForm
            data={{
              fluentLanguages: nativeLanguages?.me?.profile?.fluentLanguages,
              nativeLanguage: nativeLanguages?.me?.profile?.nativeLanguage,
            }}
            loading={loadingGetNativeLanguage}
          />
          <LanguageTable
            setLanguageState={setLanguageState}
            languageState={languageState}
            handleNextTab={handleNextTab}
            data={data?.me?.languagecertificates || []}
            refetch={refetch}
            loading={loading}
            showAddNewSection={true}
          />
        </>
      ) : (
        <LanguageForm
          setLanguageState={setLanguageState}
          pathname={location.pathname}
          supportUrl={routes.support.main}
          getLanguageInfoById={getLanguageInfoById}
          languageInfo={languageInfoByIdData?.languageCertificate?.get}
          getLanguageInfoLoading={languageInfoByIdLoading}
          userType={UserTypeEnum.USER}
        />
      )}
    </div>
  );
};

export default LanguageTabContent;
